/*
 *
 * RecordControlPanel constants
 *
 */

export const GET_FILE_HISTORY_WATCHER =
  "app/RecordControlPanel/GET_FILE_HISTORY_WATCHER"
export const GET_FILE_HISTORY_SUCCESS =
  "app/RecordControlPanel/GET_FILE_HISTORY_SUCCESS"
export const GET_FILE_HISTORY_FAILED =
  "app/RecordControlPanel/GET_FILE_HISTORY_FAILED"

export const DOWNLOAD_FILE_WATCHER =
  "app/RecordControlPanel/DOWNLOAD_FILE_WATCHER"
export const DOWNLOAD_FILE_SUCCESS =
  "app/RecordControlPanel/DOWNLOAD_FILE_SUCCESS"
export const DOWNLOAD_FILE_FAILED =
  "app/RecordControlPanel/DOWNLOAD_FILE_FAILED"
